import { useState } from "react";

export default function Page404() {

    return (
        <div className="">
            <h2>404</h2>
        </div>
    );
}